import _get from 'lodash/get';

/**
 *
 * @desc Tracking utility
 *
 */

class Analytics {

    /**
     *
     * @desc Tracks an event.
     * @param {*} event - tracking object
     * refer to https://wiki.mlbam.com/pages/viewpage.action?spaceKey=omniture&title=Omniture+Variable+Mapping
     *
     */

   static track(event) {
        const defaultMethod = () => console.log('No tracking method found.', event);
        const trackAsync = _get(window, 'trackAsync', defaultMethod);
        trackAsync(event);

    }

    static trackPageView(event) {
        const defaultMethod = () => console.log('No tracking method found.', event);
        const trackPageView = _get(window, 'trackPageView', defaultMethod);
        trackPageView(event);
    }


};

export default Analytics;
